import React from "react";
import "./common.scss";

const EmptyState = ({ label = "Nothing to show here yet." }) => (
  <div className="empty-state">
    <i className="ti ti-mood-empty"></i>
    <div className="empty-state-label">{label}</div>
  </div>
);

export default EmptyState;